<template lang="pug">
    Aside#asideFaleComAFael(:ativo="asideAtivo", @close="asideAtivo = false")
        h3 Falar com a UniFAEL é bem fácil!
        p Você só precisa deixar os dados abaixo que nós ligamos para você.
        form(@submit.prevent="sendFormulario")
            .input
                input#inputContatoNome(type="text", placeholder="Nome", v-model="formulario.nome")
                span.erro(v-if='errors.nome') {{ errors.nome[0] }}
            .input._50
                input#inputContatoCPF(type="text", placeholder="CPF", v-model="formulario.cpf", v-mask="'###.###.###-##'")
                span.erro(v-if='errors.cpf') {{ errors.cpf[0] }}
            .input._50
                input#inputContatoTelefone(type="text", placeholder="Telefone", v-model="formulario.telefone", v-mask="['(##) #####-####', '(##) ####-####']")
                span.erro(v-if='errors.telefone') {{ errors.telefone[0] }}
            .select
                select#selectContatoOpcoes(v-model="formulario.mensagem")
                    option(value="", disabled) Escolha uma opção
                    option(:value="option.value", v-for="option in options") {{ option.name }}
            .button
                button(type="submit", v-html="btnText", :disabled="disabled")
        p
            | Assim você poderá tirar todas as suas dúvidas com a UniFAEL. Nosso horário de atendimento para Inscrições
            | e Matrículas é de segunda a sábado, das 8h às 20h; para Alunos e Parceiros de segunda a sexta, das 9h às 20h.
        h4 Aguarde nosso contato!
</template>

<script>
import { mask } from 'vue-the-mask'

import Aside from '@components/Aside/Aside.vue'

export default {
    name: "component-aside-fale-com-a-fael",
    directives: {
        mask
    },
    components: {
        Aside
    },
    props: {
        ativo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        asideAtivo: {
            get() {
                return this.ativo
            },
            set(value) {
                this.$emit('update:ativo', value)
            }
        }
    },
    data() {
        return {
            btnText: 'Chamar',
            disabled: false,
            formulario: {
                nome: '',
                cpf: '',
                telefone: '',
                mensagem: ''
            },
            errors: {},
            options: [
                {
                    name: 'Quero ser aluno UniFAEL',
                    value: 'sales'
                },
                {
                    name: 'Sou Aluno UniFAEL – Informações Acadêmicas',
                    value: 'support-academico'
                },
                {
                    name: 'Sou Aluno UniFAEL – Informações Financeiras',
                    value: 'support-financeiro'
                },
                {
                    name: 'Quero ser Parceiro UniFAEL',
                    value: 'sales-partner'
                },
                {
                    name: 'Sou Parceiro UniFAEL',
                    value: 'partner'
                },
                {
                    name: 'Sou Assistente Acadêmico',
                    value: 'academicassistant'
                },
            ],
        }
    },
    methods: {
        sendFormulario() {
            this.disabled = true
            this.errors = {}
            this.btnText = 'Enviando...'
            this.$leads
                .sendFaleComAFael('custom/save-lead', this.formulario)
                .then(() => {
                    this.btnText = 'Enviado!'
                    this.formulario = Object.assign({}, {
                        nome: '',
                        cpf: '',
                        telefone: '',
                        mensagem: ''
                    })
                })
                .catch(error => {
                    this.errors = error.error_validate
                    this.btnText = 'Tente novamente'
                })
                .finally(() => {
                    setTimeout(() => {
                        this.btnText = 'Chamar'
                        this.disabled = false
                    }, 7500)
                })
        }
    },
}
</script>

<style lang="stylus" scoped src="./AsideFaleComAFael.styl"></style>
